<template>
  <Portal to="app-dialog">
    <VModal ref="modal" @modal:hidden="$emit('close')" disable-backdrop-click>
      <BaseVeeForm
        :action="createPipeline"
        v-slot="{ isPending, isRejected, invalid }"
        class="max-w-lg w-full mx-auto"
      >
        <BaseCard>
          <BaseCardHeader>
            <h3 class="text-lg leading-6 font-medium text-gray-900">New pipeline</h3>
          </BaseCardHeader>
          <BaseCardBody>
            <div class="space-y-8">
              <ValidationProvider rules="required" name="name" tag="div" vid="name">
                <template #default="{ errors, failed }">
                  <BaseFormGroup>
                    <BaseFormLabel for="name"> Pipeline name </BaseFormLabel>
                    <BaseFormInput id="name" v-model="formData.name" :disabled="isPending" />
                    <BaseFormInlineMessage v-if="failed" danger>
                      {{ errors[0] }}
                    </BaseFormInlineMessage>
                  </BaseFormGroup>
                </template>
              </ValidationProvider>
            </div>
          </BaseCardBody>
          <BaseCardFooter gray>
            <div class="flex space-x-2">
              <BaseButton primary :disabled="isPending || invalid || isRejected">
                Create pipeline
              </BaseButton>
              <BaseButton type="button" ghost :disabled="isPending" @click="$refs.modal.close()">
                Cancel
              </BaseButton>
            </div>
          </BaseCardFooter>
        </BaseCard>
      </BaseVeeForm>
    </VModal>
  </Portal>
</template>

<script>
function data() {
  return {
    loading: false,
    formData: {
      name: '',
    },
  };
}

const methods = {
  async createPipeline() {
    try {
      const { pipelineId } = await this.$store.dispatch('admin/pipelines/store', {
        formData: this.formData,
      });

      this.$emit('created', pipelineId);

      return Promise.resolve();
    } catch (error) {
      return Promise.reject(error);
    }
  },
};

export default {
  data,
  methods,
};
</script>
